import React, { useRef } from "react";
import DownloadIcon from "@mui/icons-material/Download";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import { Tooltip, Button } from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import SyncIcon from '@mui/icons-material/Sync';

const FileUpload = (props) => {
  const {
    onFileChange,
    download,
    showDownload,
    modelButton,
    spareButton,
    userButton,
    photoButton,
    downloadErrors,
    triggerPhotoUpload
  } = props;
  const inputEl = useRef(null);

  const handleClick = () => {
    if(photoButton){
      triggerPhotoUpload()
    }
    else{
      inputEl.current.click();
    }
  };

  const handleOnChange = (e) => {
    console.log('yt')
    if (onFileChange) {
      onFileChange(e);
    
      inputEl.current.value = "";
    }
    
  };
  const handleDownload = (e) => {
    if (download) {
      download(e);
    }
  };

  const handleDownloadErrorLogs = (e) => {
    if (downloadErrors) {
      downloadErrors(e);
    }
  };

  return (
    <>
      <Tooltip
        title={
          modelButton
            ? "Bulk Model Uplaod"
            : spareButton
            ? "Bulk Spare Upload"
            : userButton
            ? "Bulk User Upload"
            : photoButton
            ? "Trigger"
            : ""
        }
      >
        <Button
          variant="contained"
          onClick={handleClick}
          className="button-primary-alt-contained"
          startIcon={photoButton ? <SyncIcon/> : <FileUploadIcon />}
        >
         {photoButton ? 'Trigger' : 'Upload'}      
        </Button>
      </Tooltip>
      {showDownload ? (
        <Tooltip
          title={
            modelButton
              ? "Download Model Template"
              : spareButton
              ? "Download Spare Template"
              : userButton
              ? "Download User Template"
              : ""
          }
        >
          <Button
            variant="contained"
            className="button-primary-alt-contained"
            startIcon={<DownloadIcon />}
            sx={{ ml: 1 }}
            onClick={handleDownload}
          >
            Template
          </Button>
        </Tooltip> 
      ) : null}
      <Tooltip
        title={
          modelButton
            ? "Model Error Logs"
            : spareButton
            ? "Spare Error Logs"
            : userButton
            ? "User Error Logs"
            : photoButton
            ? "Photo Error Logs"
            : ""
        }
      >
        <Button
          variant="contained"
          className="button-primary-alt-contained"
          startIcon={<WarningAmberIcon />}
          sx={{ ml: 1 }}
          onClick={handleDownloadErrorLogs}
        >
          Error Logs
        </Button>
      </Tooltip>
      <input
        style={{ display: "none" }}
        ref={inputEl}
        accept=".csv"
        type="file"
        onChange={handleOnChange}
      />
    </>
  );
};

export default FileUpload;
